import { FieldFunctionOptions } from '@apollo/client'
import { Reference } from '@apollo/client/utilities'

export function chargePrepaidPoint() {
  return {
    merge(
      _: Reference,
      mutationIncoming: Reference,
      { cache, readField, mergeObjects }: FieldFunctionOptions
    ) {
      const prepaidPointBalance = readField<number>(
        'prepaidPointBalance',
        mutationIncoming
      )
      cache.modify({
        id: 'ROOT_QUERY',
        fields: {
          prepaidPointBalance(existingPrepaidPointBalance = { __ref: '' }) {
            const prepaidPointId = readField<string>(
              'prepaidPointId',
              existingPrepaidPointBalance
            )
            return mergeObjects(existingPrepaidPointBalance, {
              balance: prepaidPointBalance ?? 0,
              prepaidPointId,
              __typename: 'PrepaidPointBalance',
            })
          },
        },
      })
      return null
    },
  }
}
